import { blue } from '@mui/material/colors';
import { Typography } from 'shared/mui/Typography';
import { OrderAdjustments } from 'types/embedded/orderAdjustments';
import { formatCurrency } from 'utils';

type Props = {
  record: OrderAdjustments;
};

export const AdjustmentAmountFieldContent: React.FC<Props> = ({ record }) => {
  const orderCurrency = record?.order?.currency?.alphaCode;

  if (!record.newAmount && record.oldAmount) {
    return (
      <Typography noWrap variant="body2">
        {formatCurrency(record.oldAmount ?? 0)}{' '}
        <span style={{ color: blue[700] }}>{orderCurrency}</span>
      </Typography>
    );
  }
  return (
    <div>
      <Typography color="green" noWrap variant="body2">
        {formatCurrency(record.newAmount ?? 0)} {orderCurrency}
      </Typography>
      <Typography color="secondary" noWrap sx={{ textDecoration: 'line-through' }} variant="body2">
        {formatCurrency(record.oldAmount ?? 0)}{' '}
        <span style={{ color: blue[700] }}>{orderCurrency}</span>
      </Typography>
    </div>
  );
};
